import { render, staticRenderFns } from "./EarlyReturnRule.vue?vue&type=template&id=4b8efd24&scoped=true"
import script from "./EarlyReturnRule.vue?vue&type=script&setup=true&lang=js"
export * from "./EarlyReturnRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EarlyReturnRule.vue?vue&type=style&index=0&id=4b8efd24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8efd24",
  null
  
)

export default component.exports